import moment from "moment";
import { request, downloadFile, uploadFile } from "@/utils/request";
import { translationsObject } from "@/constants/translations";
import { getNumericalValue } from "@/utils/helpers";
import { DATE_FORMAT } from "@/constants/common";

export const HelpersMixin = {
  dateFormat: DATE_FORMAT,
  filters: {
    formatDate(date) {
      return date ? moment(date).format(DATE_FORMAT) : "";
    },
  },
  methods: {
    $getSearchParam(key = null) {
      const params = this.$route.query;
      if (!key) return params;
      return params[key] || null;
    },
    $setSearchParam(param, value = null) {
      const newQuery = { ...this.$route.query };
      const isQueryObject = typeof param === typeof {};
      if (!param || (isQueryObject && !Object.keys(param).length)) {
        return;
      }
      if (isQueryObject) {
        Object.entries(param).forEach(([filter, values]) => {
          const newValue = typeof values === typeof {} ? values.value : values;
          if (!newValue) delete newQuery[filter];
          else newQuery[filter] = newValue;
        });
      } else {
        if (!value) delete newQuery[param];
        else newQuery[param] = value;
      }

      this.$router
        .replace({
          query: newQuery,
        })
        .catch((err) => err);
    },
    $request(parameters) {
      return request(parameters);
    },
    $uploadFile(parameters) {
      return uploadFile(parameters);
    },
    $downloadFile(parameters) {
      return downloadFile(parameters);
    },
    $t(text, store=this.$store) {
      const language = store.state.language || "en";
      const translatedText = translationsObject[text]?.[language];
      return translatedText || text;
    },
    $te(text){
      const language = this.$store.state.language || "en";
      const translatedText = translationsObject[text]?.[language];
      return translatedText || text;
    },
    $tDate(moment_date) {
      const language = this.$store.state.language || "en";
      const format = language === "en" ? 'YYYY-DD-MM' : 'YYYY-MM-DD'
      return moment_date.format(format)
    },
    $capitalize(text) {
      return text.slice(0, 1).toUpperCase() + text.slice(1);
    },
    $getNumericalValue(value, round = 2, emptyValue='-', locale = 'fr') {
      return getNumericalValue(value, round, emptyValue, locale);
    },
  },
};
